import React from 'react';

import { SVGComponentProps } from './svg.types';

export interface RoundedLockedProps extends SVGComponentProps {
  circleFill?: string;
  lockFill?: string;
}

const RoundedLockedSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  circleFill = 'currentColor',
  lockFill = 'white',
  ...otherSvgProps
}: RoundedLockedProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <circle cx="12" cy="12" r="11.25" fill={circleFill} stroke="white" strokeWidth="1.5" />
        <g>
          <path
            d="M15.7398 10.4006V9.73971C15.7398 8.74788 15.3458 7.79667 14.6444 7.09534C13.9431 6.394 12.9919 6 12.0001 6C11.0082 6 10.057 6.394 9.35568 7.09534C8.65434 7.79667 8.26034 8.74788 8.26034 9.73971V10.4006C7.99172 10.4936 7.75806 10.6667 7.59086 10.8966C7.42365 11.1265 7.33093 11.4021 7.3252 11.6863V16.5951C7.3336 16.7903 7.38078 16.9818 7.46399 17.1585C7.54719 17.3351 7.66475 17.4935 7.80981 17.6243C7.95486 17.755 8.12451 17.8556 8.30885 17.9201C8.49319 17.9846 8.68853 18.0118 8.88348 18H15.1166C15.3114 18.0118 15.5065 17.9847 15.6907 17.9204C15.8749 17.856 16.0444 17.7557 16.1894 17.6252C16.3344 17.4947 16.452 17.3366 16.5354 17.1602C16.6187 16.9838 16.6662 16.7926 16.6749 16.5977V11.6889C16.6697 11.4042 16.5772 11.128 16.41 10.8976C16.2427 10.6672 16.0088 10.4937 15.7398 10.4006ZM12.0001 7.87029C12.4958 7.87074 12.9711 8.06781 13.3217 8.41828C13.6724 8.76874 13.8697 9.24397 13.8703 9.73971V10.2857H10.1298V9.73971C10.1304 9.24397 10.3277 8.76874 10.6784 8.41828C11.029 8.06781 11.5043 7.87074 12.0001 7.87029Z"
            fill={lockFill}
          />
        </g>
      </svg>
    </span>
  );
};

export default RoundedLockedSVG;
